import React, { useState, useEffect, useMemo, useRef, useLayoutEffect, Fragment } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import '../../../../../common/css/timeLive.css';
import { useAppSelector, useAppDispatch } from '../../../../../app/hooks';
import Select, { StylesConfig } from 'react-select';
import { ShowToast } from '../../../../../common/Toastr';
import CustomPagination from "../../../../../common/Pagination";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import CurrencyDescriptionWidget from '../../../../../features/expense/CurrencyDescriptionWidget';
import { Tooltip } from 'react-tooltip';
import {
    getEmployeeAsync, getReimburseCurrencyAsync, resetSelectedRecordObjectInState, updateAccountEmployeeId, updateExpenseSheetDate, ShowExpenseSheetStatusAsync,
    updateExpenseSheetListForSearch, updatePageSize, updatePageNumber, getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync, getValidateAccountExpensePolicyAsync,
    SubmitExpenseSheetAsync, GetDataForExpenseSheetPrintAsync, GetEmployeeExpenseSheetApprovalDetailAsync, GetSubmittedByAndSubmittedOnAsync, updateAccountExpenseSheetAsync,
    updateIsDiscriptionPopup, updateAccountExpenseEntryId, getDataForLockExpensePreviuosEntriesAsync, updateIsLockButton,
    getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync, refreshStatus,
    updateLoadClient
} from '../../../../../features/expense/expenseSlice';
import { KTSVG, KTIcon } from '../../../../helpers';
import { ShowSwalForCanvas, ShowSwalWithConfirmation } from '../../../../../common/SweetAlert';
import { ButtonGroup, DropdownButton, Dropdown } from 'react-bootstrap';
import { updatePageIdState, getPagePermissionsAsync } from '../../../../../common/GlobalSlice';
import { useTranslation } from "react-i18next";
import { formatNumberCustomoriginalapiv2, formatNumberCustomoriginal, validateCultureNumber,  determineCommaSeprater, dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../../../../common/timeLiveFunction';
import fetchAPI from '../../../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik, useFormik } from 'formik';
import { expenseSheetInitialsForUpdate } from '../../../../../features/expense/interfaces/expenseClass';
// import PageSizeSelect from '../../../common/PageSizeSelect';
import PageSizeSelect from '../../../../../common/PageSizeSelect';
import { format, parse } from 'date-fns';
import { UpdateRefreshApi } from '../../../../../features/timesheet/timesheetSlice';
const itemClass = 'ms-1 ms-lg-0';


const ToolbarExpense = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const modelRefApproval = useRef<any>(null);
    const modelRefPerDiem = useRef<any>(null);
    const navigate = useNavigate();
    const currentDate = new Date();
    const [SelectedDate, setSelectedDate] = useState(currentDate);
    // const [SelectedDate, setSelectedDate] = useState(currentDate);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [IsLockEntries, setIsLockEntries] = useState(false);
    const [employeeName, setEmployeeName] = useState<String | ''>('');
    const [isEmployeeUpdate, setIsEmployeeUpdate] = useState(false);
    const [isSearchable, setIsSearchable] = useState(true);
    const [selectedEmployee, setSelectedEmployee] = useState<{ [object: string]: any }>();
    const { employeeList, AccountEmployeeId, reimbursecurrencyList, accountCurrencyId, expenseEntryList, selectedRecord,
        expenseSheetMasterList, MasterEmployeeExpenseSheetId, IsValidatePerDiemPolicy, expenseSheetDescription, expensesheetDate,
        reimburseCurrencyId, IsSheetSubmitted, IsDescriptionPopup,
        LockAllPreviousExpenseEntries, LockAllPreviousMonthsExpenseEntries, LockButton, LockSubmittedRecord, SheetSubmitted, LockApprovedRecord, SheetApproved, approvalStatus, loadClient } = useAppSelector((state) => state.expense);

    const isPerDiemVisible = IsValidatePerDiemPolicy !== undefined ? true : false;
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const { decimalPlaces, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, sessionAccountEmployeeId, CurrentCultureDateFormat, maxMenuHeight, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, isCompanyOwnLogo, calendarStartDay } = useAppSelector((state) => state.globalState);

    const [employeeArray, setEmployeeArray] = useState<any | ''>([]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [isEmployeeEnabled, setIsEmployeeEnabled] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isModalOpen1, setIsModalOpen1] = useState<boolean>(false);
    const [clientArray, setClientArray] = useState([]);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expenseSheetInitialsForUpdate);
    const formikRef = useRef<any>(null);
    const CurrencyDescriptionWidgetRef = useRef<any>(null);
    const [isDisable, setIsDisable] = useState(true)
    const descriptionPopupRef = useRef<any>(null);
    const handleToggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };
    const location = useLocation();
    const { obj } = location.state || {};
    let AccountEmployeeExpenseSheetId = '';
    let getEmployeeName = '';
    let array: any[] = [];
    // const [isOpen, setIsOpen] = useState(false);

    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;
    } else if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }
    const isVisible = AccountEmployeeExpenseSheetId && AccountEmployeeExpenseSheetId.length > 0;


    const onDateChange = (date: any, e: any) => {
        e.stopPropagation();
        //setSelectedDate(date);
    }


     const resetFieldsToOriginal = (fields: any[]) => {
        if (AccountEmployeeExpenseSheetId !== '' && Object.keys(expenseSheetMasterList).length > 0) {
            const tempObj: any = expenseSheetMasterList[0];
            setCurrentFieldsData({
                ...currentFieldsData,
                CustomField1: tempObj.CustomField1 ? setCustomFieldValues('CustomField1', tempObj.CustomField1, fields) : getDefaultValOfSpecificCustomField('CustomField1', fields),
                CustomField2: tempObj.CustomField2 ? setCustomFieldValues('CustomField2', tempObj.CustomField2, fields) : getDefaultValOfSpecificCustomField('CustomField2', fields),
                CustomField3: tempObj.CustomField3 ? setCustomFieldValues('CustomField3', tempObj.CustomField3, fields) : getDefaultValOfSpecificCustomField('CustomField3', fields),
                CustomField4: tempObj.CustomField4 ? setCustomFieldValues('CustomField4', tempObj.CustomField4, fields) : getDefaultValOfSpecificCustomField('CustomField4', fields),
                CustomField5: tempObj.CustomField5 ? setCustomFieldValues('CustomField5', tempObj.CustomField5, fields) : getDefaultValOfSpecificCustomField('CustomField5', fields),
                CustomField6: tempObj.CustomField6 ? setCustomFieldValues('CustomField6', tempObj.CustomField6, fields) : getDefaultValOfSpecificCustomField('CustomField6', fields),
                CustomField7: tempObj.CustomField7 ? setCustomFieldValues('CustomField7', tempObj.CustomField7, fields) : getDefaultValOfSpecificCustomField('CustomField7', fields),
                CustomField8: tempObj.CustomField8 ? setCustomFieldValues('CustomField8', tempObj.CustomField8, fields) : getDefaultValOfSpecificCustomField('CustomField8', fields),
                CustomField9: tempObj.CustomField9 ? setCustomFieldValues('CustomField9', tempObj.CustomField9, fields) : getDefaultValOfSpecificCustomField('CustomField9', fields),
                CustomField10: tempObj.CustomField10 ? setCustomFieldValues('CustomField10', tempObj.CustomField10, fields) : getDefaultValOfSpecificCustomField('CustomField10', fields),
                CustomField11: tempObj.CustomField11 ? setCustomFieldValues('CustomField11', tempObj.CustomField11, fields) : getDefaultValOfSpecificCustomField('CustomField11', fields),
                CustomField12: tempObj.CustomField12 ? setCustomFieldValues('CustomField12', tempObj.CustomField12, fields) : getDefaultValOfSpecificCustomField('CustomField12', fields),
                CustomField13: tempObj.CustomField13 ? setCustomFieldValues('CustomField13', tempObj.CustomField13, fields) : getDefaultValOfSpecificCustomField('CustomField13', fields),
                CustomField14: tempObj.CustomField14 ? setCustomFieldValues('CustomField14', tempObj.CustomField14, fields) : getDefaultValOfSpecificCustomField('CustomField14', fields),
                CustomField15: tempObj.CustomField15 ? setCustomFieldValues('CustomField15', tempObj.CustomField15, fields) : getDefaultValOfSpecificCustomField('CustomField15', fields),
            });
        } else {
            expenseSheetInitialsForUpdate.CustomField1 = getDefaultValOfSpecificCustomField('CustomField1', fields);
            expenseSheetInitialsForUpdate.CustomField2 = getDefaultValOfSpecificCustomField('CustomField2', fields);
            expenseSheetInitialsForUpdate.CustomField3 = getDefaultValOfSpecificCustomField('CustomField3', fields);
            expenseSheetInitialsForUpdate.CustomField4 = getDefaultValOfSpecificCustomField('CustomField4', fields);
            expenseSheetInitialsForUpdate.CustomField5 = getDefaultValOfSpecificCustomField('CustomField5', fields);
            expenseSheetInitialsForUpdate.CustomField6 = getDefaultValOfSpecificCustomField('CustomField6', fields);
            expenseSheetInitialsForUpdate.CustomField7 = getDefaultValOfSpecificCustomField('CustomField7', fields);
            expenseSheetInitialsForUpdate.CustomField8 = getDefaultValOfSpecificCustomField('CustomField8', fields);
            expenseSheetInitialsForUpdate.CustomField9 = getDefaultValOfSpecificCustomField('CustomField9', fields);
            expenseSheetInitialsForUpdate.CustomField10 = getDefaultValOfSpecificCustomField('CustomField10', fields);
            expenseSheetInitialsForUpdate.CustomField11 = getDefaultValOfSpecificCustomField('CustomField11', fields);
            expenseSheetInitialsForUpdate.CustomField12 = getDefaultValOfSpecificCustomField('CustomField12', fields);
            expenseSheetInitialsForUpdate.CustomField13 = getDefaultValOfSpecificCustomField('CustomField13', fields);
            expenseSheetInitialsForUpdate.CustomField14 = getDefaultValOfSpecificCustomField('CustomField14', fields);
            expenseSheetInitialsForUpdate.CustomField15 = getDefaultValOfSpecificCustomField('CustomField15', fields);
            setCurrentFieldsData({ ...expenseSheetInitialsForUpdate });
        }
        formik.resetForm();
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                IsDescriptionPopup &&
                descriptionPopupRef.current &&
                !descriptionPopupRef.current.contains(event.target as Node)
            ) {
                dispatch(updateIsDiscriptionPopup(false));
                resetFieldsToOriginal(customFieldsArray);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [IsDescriptionPopup, expenseSheetMasterList, customFieldsArray, AccountEmployeeExpenseSheetId]);

    const Clients = async () => {
        try {
            const response = await fetchAPI('api/V2/Clients/Active', "GET", "", true);
            const json = await response.json();
            if (json.StatusCode === '200') {
                setClientArray(json.Data);
                setIsDisable(false);
                dispatch(updateLoadClient(false));
            }else{
                setIsDisable(false);
            }
        } catch (error) {
        } finally {
            setIsDisable(false);
        }
    }

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const validationSchema = yup.object().shape({
        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        yupSchema = yup.string().trim();
                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    return [x.DatabaseFieldName, yupSchema];
                })
        ),
    });
    const handleBlurValidateAll = (setFieldTouched: any, values: any, validateForm: any) => {
        // Mark all fields as touched
        Object.keys(values).forEach(field => {
            setFieldTouched(field, true);
        });

        // Validate all fields
        validateForm();
    };

    const formik = useFormik({
        initialValues: currentFieldsData,
        enableReinitialize: true,
        onSubmit: (values, actions) => {
            if (values.buttonClicked === 'handlSubmitSheet') {
                handlSubmitSheet();
            } else if (values.buttonClicked === 'handleUpdateSheet') {
                if (CurrencyDescriptionWidgetRef.current) {
                    CurrencyDescriptionWidgetRef.current.childMethod();
                }
            }
            // setIsOpen(false);
            actions.resetForm();
        },
        validationSchema: validationSchema,
        innerRef: formikRef
    });

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
        dispatch(updatePageNumber(pageNumber));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
        dispatch(updateExpenseSheetListForSearch(value));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
        dispatch(updatePageSize(value));
    };

        const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsArray.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const updateExpenseSheetMasterList = (expenseSheetMasterList: any, SelectedExpenseSheetDate?: any) => {
        return expenseSheetMasterList.map((item: any) => {
            const updatedItem = {
                ...item,
                AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId,
                AccountEmployeeId: AccountEmployeeId,
                ExpenseSheetDate: SelectedExpenseSheetDate || moment(SelectedDate).format(dateInsertionFormat),
                //ExpenseSheetDate: SelectedExpenseSheetDate || SelectedDate,
                Description: expenseSheetDescription,
                ReimbursementCurrencyId: reimburseCurrencyId,
                'CustomField1':  getFormattedCustomField('CustomField1', formik.values.CustomField1), 
                'CustomField2': getFormattedCustomField('CustomField2', formik.values.CustomField2),
                'CustomField3': getFormattedCustomField('CustomField3', formik.values.CustomField3),
                'CustomField4': getFormattedCustomField('CustomField4', formik.values.CustomField4),
                'CustomField5': getFormattedCustomField('CustomField5', formik.values.CustomField5),
                'CustomField6': getFormattedCustomField('CustomField6', formik.values.CustomField6), 
                'CustomField7': getFormattedCustomField('CustomField7', formik.values.CustomField7),
                'CustomField8': getFormattedCustomField('CustomField8', formik.values.CustomField8),
                'CustomField9': getFormattedCustomField('CustomField9', formik.values.CustomField9), 
                'CustomField10': getFormattedCustomField('CustomField10', formik.values.CustomField10),
                'CustomField11': getFormattedCustomField('CustomField11', formik.values.CustomField11), 
                'CustomField12': getFormattedCustomField('CustomField11', formik.values.CustomField12),
                'CustomField13': getFormattedCustomField('CustomField13', formik.values.CustomField13),
                'CustomField14': getFormattedCustomField('CustomField14', formik.values.CustomField14),
                'CustomField15': getFormattedCustomField('CustomField15', formik.values.CustomField15),
            };
            // Exclude specific columns
            delete updatedItem.Amount;
            delete updatedItem.EMailAddress;
            delete updatedItem.EmployeeName;
            delete updatedItem.Currency;
            delete updatedItem.CurrencyCode;
            delete updatedItem.AccountCurrencyId;
            delete updatedItem.Status;
            return updatedItem;
        });
    };

    const handlSubmitSheet = () => {
        const forSubmitExpeseSheetList = updateExpenseSheetMasterList(expenseSheetMasterList);
        if (AccountEmployeeExpenseSheetId !== '') {
            dispatch(SubmitExpenseSheetAsync({ AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId, 'ExpeseSheetList': forSubmitExpeseSheetList }))
                .unwrap()
                .then((originalPromiseResult) => {
                    if(originalPromiseResult.StatusCode === "200") {
                        ShowToast(originalPromiseResult.ResponseMessage, 'Success', "success", "toast-top-right") 
                        dispatch(UpdateRefreshApi(true))
                    }else{
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    }
                    if (AccountEmployeeExpenseSheetId !== null) {
                        dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId)).unwrap()
                            .then((res) => {
                                dispatch(UpdateRefreshApi(true))
                                //  setIsOpen(false); 
                            })
                    }
                    // setIsOpen(false);
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }

    }


    const LockExpenseEntriesByExpensePolicy = (selectDate: any, isUpdate: boolean = false) => {
        const currentdate = moment(new Date()).format("YYYY/MM/DD");
        const CurrentMonth = moment().format("YYYY,MM");
        const CurrentYear = moment(currentdate).format("YYYY");
        const ExpenseSheetSelectedDate = moment(selectDate).format("YYYY/MM/DD");
        const ExpenseSheetSelectedMonth = moment(selectDate).format("YYYY,MM");
        const ExpenseSheetSelectedYear = moment(selectDate).format("YYYY");
        const SheetSelectedDate = new Date(ExpenseSheetSelectedDate);
        const Current = new Date(currentdate);
        if (AccountEmployeeId) {
            dispatch(getDataForLockExpensePreviuosEntriesAsync(AccountEmployeeId)).then((data) => {
                dispatch(updateIsLockButton(false));
                if (data.payload.LockAllPreviousExpenseEntries || data.payload.LockAllPreviousMonthsExpenseEntries) {
                    if (data.payload.LockAllPreviousExpenseEntries) {
                        if (ExpenseSheetSelectedYear <= CurrentYear && SheetSelectedDate < Current) {
                            dispatch(updateIsLockButton(true));
                        } else {
                            dispatch(updateIsLockButton(false));
                            if (isUpdate){
                                if (AccountEmployeeExpenseSheetId !== '') {
                                    const ExpenseSheetData = updateExpenseSheetMasterList(expenseSheetMasterList, moment(selectDate).format(dateInsertionFormat));
                                    dispatch(updateAccountExpenseSheetAsync({ AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId, ExpenseSheetData: ExpenseSheetData }))
                                        .unwrap()
                                        .then((originalPromiseResult) => {
                                            originalPromiseResult.StatusCode === "200" ?
                                                ShowToast('Expense Sheet Successfully Update', 'Success', "success", "toast-top-right") :
                                                ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                                        })
                                        .catch((rejectedValueOrSerializedError) => {
                                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                                        })
                                }
                            }
                        }

                    } else if (data.payload.LockAllPreviousMonthsExpenseEntries) {
                        if (ExpenseSheetSelectedYear <= CurrentYear && ExpenseSheetSelectedMonth < CurrentMonth) {
                            dispatch(updateIsLockButton(true));

                        } else {
                            dispatch(updateIsLockButton(false));
                            if (isUpdate) {
                                if (AccountEmployeeExpenseSheetId !== '') {
                                    const ExpenseSheetData = updateExpenseSheetMasterList(expenseSheetMasterList, moment(selectDate).format(dateInsertionFormat));
                                    dispatch(updateAccountExpenseSheetAsync({ AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId, ExpenseSheetData: ExpenseSheetData }))
                                        .unwrap()
                                        .then((originalPromiseResult) => {
                                            originalPromiseResult.StatusCode === "200" ?
                                                ShowToast('Expense Sheet Successfully Update', 'Success', "success", "toast-top-right") :
                                                ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                                        })
                                        .catch((rejectedValueOrSerializedError) => {
                                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                                        })
                                }
                            }
                        }
                    }
                } else {
                    if (isUpdate) {
                        if (AccountEmployeeExpenseSheetId !== '') {
                            const ExpenseSheetData = updateExpenseSheetMasterList(expenseSheetMasterList, moment(selectDate).format(dateInsertionFormat));
                            dispatch(updateAccountExpenseSheetAsync({ AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId, ExpenseSheetData: ExpenseSheetData }))
                                .unwrap()
                                .then((originalPromiseResult) => {
                                    dispatch(updateIsLockButton(false));
                                    originalPromiseResult.StatusCode === "200" ?
                                        ShowToast('Expense Sheet Successfully Update', 'Success', "success", "toast-top-right") :
                                        ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                                })
                                .catch((rejectedValueOrSerializedError) => {
                                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                                })
                        }
                    }

                }
            });
        }
    }

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = expenseEntryList.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = expenseEntryList.length;
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    useEffect(() => {
        dispatch(getEmployeeAsync());
        dispatch(getDataForLockExpensePreviuosEntriesAsync(AccountEmployeeId));
    }, [AccountEmployeeId]);

/*     useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync();
    }, []); */

const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        
        // Safety check if field definition is not found
        if (!foundItem) return customFieldData;

        if (foundItem.MasterCustomDataTypeName === 'Date') {
            return customFieldData;
        } 
        else if (foundItem.MasterCustomDataTypeName === 'Number') {
            if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, decimalPlaces);
            }
            return customFieldData;
        } 
        else {
            return customFieldData;
        }
    }

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync().then((result) => {
        if (AccountEmployeeExpenseSheetId !== '') {            
            if (Object.keys(expenseSheetMasterList).length > 0) {
                const tempObj: any = expenseSheetMasterList[0];
                const EmployeeValue = tempObj.AccountEmployeeId;
                setSelectedOption({ value: EmployeeValue, label: tempObj.EmployeeName });
                dispatch(updateAccountEmployeeId(EmployeeValue));
                setIsEmployeeEnabled(false);
                // const sheetdate = moment(tempObj.ExpenseSheetDate).format('YYYY-MM-DD');
                const sheetdate = dateFormatByAccountCulture(tempObj.ExpenseSheetDate, cultureInfoName.toString());
                // setSelectedDate(new Date(sheetdate));
                setSelectedDate(sheetdate);
                dispatch(updateExpenseSheetDate(moment.parseZone(tempObj.ExpenseSheetDate).format('YYYY-MM-DD')));
                // LockExpenseEntriesByExpensePolicy(new Date(sheetdate));
                LockExpenseEntriesByExpensePolicy(sheetdate);
                dispatch(GetSubmittedByAndSubmittedOnAsync(AccountEmployeeExpenseSheetId));
                if (customFieldsArray && customFieldsArray.length > 0) {
                    setCurrentFieldsData({
                        ...currentFieldsData,
                        'CustomField1': tempObj.CustomField1 ? setCustomFieldValues('CustomField1', tempObj.CustomField1, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField1', customFieldsArray),
                        'CustomField2': tempObj.CustomField2 ? setCustomFieldValues('CustomField2', tempObj.CustomField2, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField2', customFieldsArray),
                        'CustomField3': tempObj.CustomField3 ? setCustomFieldValues('CustomField3', tempObj.CustomField3, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField3', customFieldsArray),
                        'CustomField4': tempObj.CustomField4 ? setCustomFieldValues('CustomField4', tempObj.CustomField4, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField4', customFieldsArray),
                        'CustomField5': tempObj.CustomField5 ? setCustomFieldValues('CustomField5', tempObj.CustomField5, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField5', customFieldsArray),
                        'CustomField6': tempObj.CustomField6 ? setCustomFieldValues('CustomField6', tempObj.CustomField6, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField6', customFieldsArray),
                        'CustomField7': tempObj.CustomField7 ? setCustomFieldValues('CustomField7', tempObj.CustomField7, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField7', customFieldsArray),
                        'CustomField8': tempObj.CustomField8 ? setCustomFieldValues('CustomField8', tempObj.CustomField8, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField8', customFieldsArray),
                        'CustomField9': tempObj.CustomField9 ? setCustomFieldValues('CustomField9', tempObj.CustomField9, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField9', customFieldsArray),
                        'CustomField10': tempObj.CustomField10 ? setCustomFieldValues('CustomField10', tempObj.CustomField10, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField10', customFieldsArray),
                        'CustomField11': tempObj.CustomField11 ? setCustomFieldValues('CustomField11', tempObj.CustomField11, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField11', customFieldsArray),
                        'CustomField12': tempObj.CustomField12 ? setCustomFieldValues('CustomField12', tempObj.CustomField12, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField12', customFieldsArray),
                        'CustomField13': tempObj.CustomField13 ? setCustomFieldValues('CustomField13', tempObj.CustomField13, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField13', customFieldsArray),
                        'CustomField14': tempObj.CustomField14 ? setCustomFieldValues('CustomField14', tempObj.CustomField14, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField14', customFieldsArray),
                        'CustomField15': tempObj.CustomField15 ? setCustomFieldValues('CustomField15', tempObj.CustomField15, customFieldsArray) : getDefaultValOfSpecificCustomField('CustomField15', customFieldsArray)
                    })
                }
            }
        } else {
            dispatch(refreshStatus(false));
            employeeList.map(item => {
                array.push({ value: item.AccountEmployeeId, label: item.EmployeeName })
                if (item != undefined && Number(item.AccountEmployeeId) == AccountEmployeeId) {
                    getEmployeeName = item.EmployeeName;
                }
            });
            setSelectedOption({ value: AccountEmployeeId, label: getEmployeeName });
            setIsEmployeeEnabled(true);
            setSelectedDate(new Date());
            LockExpenseEntriesByExpensePolicy(new Date());
            if (customFieldsArray && customFieldsArray.length > 0) {
                expenseSheetInitialsForUpdate.CustomField1 = getDefaultValOfSpecificCustomField('CustomField1', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField2 = getDefaultValOfSpecificCustomField('CustomField2', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField3 = getDefaultValOfSpecificCustomField('CustomField3', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField4 = getDefaultValOfSpecificCustomField('CustomField4', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField5 = getDefaultValOfSpecificCustomField('CustomField5', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField6 = getDefaultValOfSpecificCustomField('CustomField6', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField7 = getDefaultValOfSpecificCustomField('CustomField7', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField8 = getDefaultValOfSpecificCustomField('CustomField8', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField9 = getDefaultValOfSpecificCustomField('CustomField9', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField10 = getDefaultValOfSpecificCustomField('CustomField10', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField11 = getDefaultValOfSpecificCustomField('CustomField11', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField12 = getDefaultValOfSpecificCustomField('CustomField12', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField13 = getDefaultValOfSpecificCustomField('CustomField13', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField14 = getDefaultValOfSpecificCustomField('CustomField14', customFieldsArray);
                expenseSheetInitialsForUpdate.CustomField15 = getDefaultValOfSpecificCustomField('CustomField15', customFieldsArray);
                setCurrentFieldsData(expenseSheetInitialsForUpdate);
            }
        }
        }).catch((error) => {
        });
    }, [AccountEmployeeExpenseSheetId, expenseSheetMasterList, AccountEmployeeId])

    // useEffect(() => {
    //     getCustomFieldTemplateByMasterEntityTypeIdAsync().then((result) => {
    //         if (AccountEmployeeExpenseSheetId !== '' && Object.keys(expenseSheetMasterList).length > 0) {
    //             const tempObj: any = expenseSheetMasterList[0];
    //             const EmployeeValue = tempObj.AccountEmployeeId;
    //             setSelectedOption({ value: EmployeeValue, label: tempObj.EmployeeName });
    //             dispatch(updateAccountEmployeeId(EmployeeValue));
    //             setIsEmployeeEnabled(false);
    //             const sheetdate = moment(tempObj.ExpenseSheetDate).format('YYYY-MM-DD');
    //             setSelectedDate(new Date(sheetdate));
    //             dispatch(updateExpenseSheetDate(moment(tempObj.ExpenseSheetDate).format("YYYY-MM-DD")));

    //             LockExpenseEntriesByExpensePolicy(new Date(sheetdate));
    //             dispatch(getValidateAccountExpensePolicyAsync(EmployeeValue));
    //             dispatch(GetSubmittedByAndSubmittedOnAsync(AccountEmployeeExpenseSheetId));
    //             setCurrentFieldsData({
    //                 ...currentFieldsData,
    //                 'CustomField1': tempObj.CustomField1 ? tempObj.CustomField1 : getDefaultValOfSpecificCustomField('CustomField1', result),
    //                 'CustomField2': tempObj.CustomField2 ? tempObj.CustomField2 : getDefaultValOfSpecificCustomField('CustomField2', result),
    //                 'CustomField3': tempObj.CustomField3 ? tempObj.CustomField3 : getDefaultValOfSpecificCustomField('CustomField3', result),
    //                 'CustomField4': tempObj.CustomField4 ? tempObj.CustomField4 : getDefaultValOfSpecificCustomField('CustomField4', result),
    //                 'CustomField5': tempObj.CustomField5 ? tempObj.CustomField5 : getDefaultValOfSpecificCustomField('CustomField5', result),
    //                 'CustomField6': tempObj.CustomField6 ? tempObj.CustomField6 : getDefaultValOfSpecificCustomField('CustomField6', result),
    //                 'CustomField7': tempObj.CustomField7 ? tempObj.CustomField7 : getDefaultValOfSpecificCustomField('CustomField7', result),
    //                 'CustomField8': tempObj.CustomField8 ? tempObj.CustomField8 : getDefaultValOfSpecificCustomField('CustomField8', result),
    //                 'CustomField9': tempObj.CustomField9 ? tempObj.CustomField9 : getDefaultValOfSpecificCustomField('CustomField9', result),
    //                 'CustomField10': tempObj.CustomField10 ? tempObj.CustomField10 : getDefaultValOfSpecificCustomField('CustomField10', result),
    //                 'CustomField11': tempObj.CustomField11 ? tempObj.CustomField11 : getDefaultValOfSpecificCustomField('CustomField11', result),
    //                 'CustomField12': tempObj.CustomField12 ? tempObj.CustomField12 : getDefaultValOfSpecificCustomField('CustomField12', result),
    //                 'CustomField13': tempObj.CustomField13 ? tempObj.CustomField13 : getDefaultValOfSpecificCustomField('CustomField13', result),
    //                 'CustomField14': tempObj.CustomField14 ? tempObj.CustomField14 : getDefaultValOfSpecificCustomField('CustomField14', result),
    //                 'CustomField15': tempObj.CustomField15 ? tempObj.CustomField15 : getDefaultValOfSpecificCustomField('CustomField15', result)
    //             })
    //         }
    //         else {
    //             employeeList.map(item => {
    //                 array.push({ value: item.AccountEmployeeId, label: item.EmployeeName })
    //                 if (item != undefined && Number(item.AccountEmployeeId) == AccountEmployeeId) {
    //                     getEmployeeName = item.EmployeeName;
    //                 }
    //             });
    //             setSelectedOption({ value: AccountEmployeeId, label: getEmployeeName });
    //             setIsEmployeeEnabled(true);
    //             setSelectedDate(new Date());
    //             LockExpenseEntriesByExpensePolicy(new Date());
    // expenseSheetInitialsForUpdate.CustomField1 = getDefaultValOfSpecificCustomField('CustomField1', result);
    // expenseSheetInitialsForUpdate.CustomField2 = getDefaultValOfSpecificCustomField('CustomField2', result);
    // expenseSheetInitialsForUpdate.CustomField3 = getDefaultValOfSpecificCustomField('CustomField3', result);
    // expenseSheetInitialsForUpdate.CustomField4 = getDefaultValOfSpecificCustomField('CustomField4', result);
    // expenseSheetInitialsForUpdate.CustomField5 = getDefaultValOfSpecificCustomField('CustomField5', result);
    // expenseSheetInitialsForUpdate.CustomField6 = getDefaultValOfSpecificCustomField('CustomField6', result);
    // expenseSheetInitialsForUpdate.CustomField7 = getDefaultValOfSpecificCustomField('CustomField7', result);
    // expenseSheetInitialsForUpdate.CustomField8 = getDefaultValOfSpecificCustomField('CustomField8', result);
    // expenseSheetInitialsForUpdate.CustomField9 = getDefaultValOfSpecificCustomField('CustomField9', result);
    // expenseSheetInitialsForUpdate.CustomField10 = getDefaultValOfSpecificCustomField('CustomField10', result);
    // expenseSheetInitialsForUpdate.CustomField11 = getDefaultValOfSpecificCustomField('CustomField11', result);
    // expenseSheetInitialsForUpdate.CustomField12 = getDefaultValOfSpecificCustomField('CustomField12', result);
    // expenseSheetInitialsForUpdate.CustomField13 = getDefaultValOfSpecificCustomField('CustomField13', result);
    // expenseSheetInitialsForUpdate.CustomField14 = getDefaultValOfSpecificCustomField('CustomField14', result);
    // expenseSheetInitialsForUpdate.CustomField15 = getDefaultValOfSpecificCustomField('CustomField15', result);
    // setCurrentFieldsData(expenseSheetInitialsForUpdate);
    //         }
    //     }).catch((error) => {
    //     });
    // }, [AccountEmployeeExpenseSheetId, expenseSheetMasterList, AccountEmployeeId])

    const getDefaultValOfSpecificCustomField = (customField: string, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        if (foundItem) {
            //return foundItem.MasterCustomDataTypeName === 'Date' ? moment().format(CurrentCultureDateFormat.toUpperCase()) : (foundItem.DefaultValue || '');
            return foundItem.MasterCustomDataTypeName === 'Date' ? moment(new Date()).format(customFieldInsertionFormat) : (foundItem.DefaultValue || '');
        } else {
            return '';
        }
    }

    useEffect(() => {
        Clients();
        document.body.setAttribute('data-kt-app-toolbar-fixed', 'true');
    }, [loadClient])


    const handleDateChange = (selectedDate: any) => {
        setSelectedDate(selectedDate);
        LockExpenseEntriesByExpensePolicy(selectedDate, true);
        dispatch(updateExpenseSheetDate(moment(selectedDate).format(dateInsertionFormat)));
    }

    useEffect(() => {
        dispatch(updateExpenseSheetDate(moment(SelectedDate).format(dateInsertionFormat)));
    }, [SelectedDate])



    // let getEmployeeName = '';
    // let array: any[] = [];
    // employeeList.map(item => {
    //     array.push({ value: item.AccountEmployeeId, label: item.EmployeeName })
    //     if (item != undefined && Number(item.AccountEmployeeId) == sessionAccountEmployeeId) {
    //         getEmployeeName = item.EmployeeName;
    //     }
    // });
    // if (getEmployeeName != employeeName && getEmployeeName != undefined && isEmployeeUpdate == false) {
    //     setEmployeeName(getEmployeeName);
    //     if (array[0] != undefined) {
    //         setSelectedOption(array.filter(x => x.value == sessionAccountEmployeeId)[0]);
    //     }
    //     setEmployeeArray(array);
    // }

    const onEmployeeChange = (data: any) => {
        setIsEmployeeUpdate(true);
        dispatch(updateAccountEmployeeId(data.value));
        setSelectedOption(data);
        dispatch(getValidateAccountExpensePolicyAsync(data.value));
    }

    const ExpenseSheetObject = {
        "SheetEmployeeId": selectedOption?.value,
        "SheetDate": SelectedDate,
        "SheetReimburseCurrency": 0,
        "SheetDescription": (moment(SelectedDate).format(dateInsertionFormat)),
    }


    const handleOnClickEvent = () => {
        dispatch(updateAccountExpenseEntryId(0));
        dispatch(resetSelectedRecordObjectInState());

        setIsModalOpen(true);
        setShowDropdown(false);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleOnClickPrintEvent = () => {
        setIsModalOpen1(false);
        modelRef.current.click();
        dispatch(GetDataForExpenseSheetPrintAsync(AccountEmployeeExpenseSheetId));
    }

    const handleOnClickApprovalEvent = () => {
        setIsModalOpen1(true);
        modelRefApproval.current.click();
    }

    const handleExpenseEntry = () => {
        dispatch(resetSelectedRecordObjectInState());
        if (clientArray.length > 0) {
            dispatch(updateAccountExpenseEntryId(0));
        } else {
            ShowSwalForCanvas('No Client found', "Please add Client before creating Project", "warning");
        }
    }

    const handleExpenseEntryGroupClick = () => {
        dispatch(resetSelectedRecordObjectInState());
        if (clientArray.length > 0) {
            dispatch(updateAccountExpenseEntryId(0));
        } else {
            ShowSwalForCanvas('No Client found', "Please add Client before creating Project", "warning");
        }
    }

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = 'A55DF02B-FBFB-4873-B582-6968FBAEE589';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, '');
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }
    const handleCustomFieldChange = (id: string, value: any) => {
        let obj = { key: id, value: value };

        setCurrentFieldsData({
            ...currentFieldsData,
            [id]: value
        })
    }

    useEffect(() => {
        if (employeeList && employeeList.length > 0) {
            let array: any[] = [];
            let getEmployeeName = '';

            employeeList.map(item => {
                array.push({ value: item.AccountEmployeeId, label: item.EmployeeName });
                if (Number(item.AccountEmployeeId) == sessionAccountEmployeeId) {
                    getEmployeeName = item.EmployeeName;
                }
            });

            setEmployeeArray(array);

            if (!AccountEmployeeExpenseSheetId && !isEmployeeUpdate) {
                const defaultOption = array.find(x => x.value == sessionAccountEmployeeId);
                if (defaultOption) {
                    setSelectedOption(defaultOption);
                    setEmployeeName(defaultOption.label);
                }
            }
        }
    }, [employeeList]);

    return (
        <>

            <div className='d-flex align-items-center me-5' style={{ marginTop: 5 }}>
                <Select
                    value={selectedOption}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={isSearchable}
                    name="employeeList"
                    onChange={onEmployeeChange}
                    options={employeeArray}
                    styles={colourStyles}
                    isDisabled={!isEmployeeEnabled}
                />
                <div className='bullet bg-secondary h-35px w-1px mx-2'></div>
                {/* <div className='d-flex align-items-center flex-shrink-0 tsPeriodDateRange'>
                    <div className='d-flex flex-shrink-0'>
                        <DatePicker
                            selected={SelectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            className="form-control dataPickerExpense w-100px ps-4 fs-7 fs-7 fw-normal btn-icon-dark btn-text-dark"
                        />
                    </div>
                </div> */}
                <div className='esCopyDatepicker'>
                    <div className='d-flex flex-shrink-0'>
                        <DatePicker
                            selected={SelectedDate}
                            onChange={handleDateChange}
                            calendarStartDay={calendarStartDay}
                            disabled={(SheetSubmitted && LockSubmittedRecord) || (SheetApproved && LockApprovedRecord)}
                            customInput={<a style={{ cursor: 'pointer' }} >
                                <div className='d-flex align-items-center flex-wrap' style={{ marginTop: 0, marginLeft: 15, textAlign: 'center' }}>
                                    {/* <span className='fs-7 fw-normal d-md-block headerTitleColor'>{moment(SelectedDate).format("M-D-YYYY")} */}
                                    <span className='fs-7 fw-normal d-md-block headerTitleColor'>{format(SelectedDate, CurrentCultureDateFormat.toString())}
                                    </span>
                                    <a className='btn btn-sm btn-icon btn-icon-primary show'>
                                        <i className="ki-outline ki-calendar iconColor fs-3"></i>
                                    </a>
                                </div>
                            </a>}
                        // dateFormat={CurrentCultureDateFormat.toString()}
                        />
                    </div>
                </div>


                <div className='bullet bg-secondary h-35px w-1px mx-2'></div>
                <div className={clsx('app-navbar-item', itemClass)} ref={descriptionPopupRef}>
                    <div className={clsx('cursor-pointer symbol')}
                        data-kt-menu-trigger="{default: 'click'}"
                        data-kt-menu-attach='parent'
                        data-kt-menu-placement='bottom-end'
                    >
                        <span
                            className={`btn btn-icon ${formik.isValid ? 'btn-active-light-dark' : 'btn-light-danger pulse pulse-danger'}   btn-sm ms-0 fs-7`}
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content={customFieldsArray && customFieldsArray.length > 0
                                ? getValueFromResource('Expense Sheet Description & Custom Fields', dispatch, t)
                                : getValueFromResource('Expense Sheet Description', dispatch, t)}
                            data-tooltip-place="bottom"
                        >
                            <i className="bi bi-pencil-square fs-3 iconColor"
                                onClick={() => dispatch(updateIsDiscriptionPopup(true))}
                            //onClick={()=>setIsOpen(true)}
                            ></i>
                            {!formik.isValid && <span className="pulse-ring"></span>}
                            {/* <i  className="bi bi-pencil-square fs-3 iconColor" onClick={() => dispatch(updateIsDiscriptionPopup(true))}></i> */}
                        </span>
                    </div>
                    <>
                        <div
                            className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary px-1 fs-6 w-350px`}
                            data-kt-menu='true'
                        >
                            {IsDescriptionPopup &&
                                <div className={"row tsDescriptionWidget "}>
                                    <CurrencyDescriptionWidget SelectedDate={SelectedDate} lockButton={LockButton} formik={formik} ref={CurrencyDescriptionWidgetRef} customFieldArray2={customFieldsArray}/>
                                    
                                        <>
                                            {customFieldsArray && customFieldsArray.length > 0 &&
                                                <div className={"col-md-12 col-sm-12 col-xs-12"}>
                                                    <h4 className="card-title fw-bold titleHeading ">
                                                        {/* {t(`Custom Fields`)} */}
                                                        {getValueFromResource('Custom Fields', dispatch, t)}
                                                    </h4>
                                                    <div className="separator my-2 "></div>
                                                    <div style={{ maxHeight: '200px', overflowY: 'scroll' }}>
                                                        {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                                            <Fragment key={index}>
                                                                {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                                    // <>
                                                                    <div
                                                                        data-kt-menu-dismiss="false"
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <div key={`${index}-${x.DatabaseFieldName}`} className={"mb-1 "}>
                                                                            <label className={"fs-7 fw-normal mb-1"}>{x.CustomFieldCaption}</label>

                                                                            <Select
                                                                                name={x.DatabaseFieldName}
                                                                                className="basic-single fs-7 fw-normal"
                                                                                onChange={(e: any) => handleCustomFieldChange(x.DatabaseFieldName, e?.value)}
                                                                                value={formik.values[x.DatabaseFieldName] ? { value: formik.values[x.DatabaseFieldName], label: formik.values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                                                options={[
                                                                                    { value: 'None', label: 'None' },
                                                                                    ...x.DropDownOptions
                                                                                        ? x.DropDownOptions.split("+").map((value: any) => ({ value, label: value }))
                                                                                        : []
                                                                                ]}
                                                                                // options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                                                required={x.IsRequired ? x.IsRequired : ""}
                                                                                maxMenuHeight={maxMenuHeight}
                                                                                menuPlacement='auto'
                                                                            />
                                                                            {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                                                <div style={{ paddingRight: 20 }}>
                                                                                    {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                                        <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                                                    }
                                                                                </div>
                                                                            )}

                                                                        </div>

                                                                    {/* </> */}
                                                                    </div>
                                                                )}
                                                                {x.MasterCustomDataTypeName == "Date" && (
                                                                    <>
                                                                        <div key={`${index}-${x.DatabaseFieldName}`} className={" mb-1 "}>
                                                                            <label className={" fs-7 fw-normal mb-1"}>{x.CustomFieldCaption}</label>

                                                                            <DatePicker
                                                                                name={x.DatabaseFieldName}
                                                                                calendarStartDay={calendarStartDay}
                                                                                //onChange={(date) => formik.setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                                //selected={(formik.values[x.DatabaseFieldName] ? moment(formik.values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                                onChange={(date, e) => {
                                                                                    onDateChange(date, e);
                                                                                    formik.setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(customFieldInsertionFormat) : moment(new Date()).format(customFieldInsertionFormat))
                                                                                }}
                                                                                selected={(formik.values[x.DatabaseFieldName] ? dateFormatByAccountCulture(formik.values[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                                                className={"form-control fs-7 fs-7 fw-normal"}
                                                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                                                onBlur={() => handleBlurValidateAll(formik.setFieldTouched, formik.values, formik.validateForm)}
                                                                            />
                                                                            {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                                                <div style={{ paddingRight: 20 }}>
                                                                                    {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                                        <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                                                    }
                                                                                </div>
                                                                            )}

                                                                        </div>
                                                                    </>
                                                                )}

                                                                {(x.MasterCustomDataTypeName == "Text") && (
                                                                    <div key={`${index}-${x.DatabaseFieldName}`} className={" mb-1 "}>
                                                                        <label className={" fs-7 fw-normal mb-1"}>{x.CustomFieldCaption}</label>

                                                                        <input
                                                                            name={x.DatabaseFieldName}
                                                                            id={x.DatabaseFieldName}
                                                                            value={formik.values[x.DatabaseFieldName] ? formik.values[x.DatabaseFieldName] : ''}
                                                                            onChange={(e: any) => handleCustomFieldChange(x.DatabaseFieldName, e.target.value)}
                                                                            className={"form-control fs-7 fs-7 fw-normal"}
                                                                            required={x.IsRequired ? x.IsRequired : ""}
                                                                            type="text"
                                                                            onBlur={() => handleBlurValidateAll(formik.setFieldTouched, formik.values, formik.validateForm)}
                                                                        />
                                                                        {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                                            <div style={{ paddingRight: 20 }}>
                                                                                {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                                    <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                                                }
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                )}

                                                                {(x.MasterCustomDataTypeName == "Number") && (
                                                                    <div key={`${index}-${x.DatabaseFieldName}`} className={" mb-1 "}>
                                                                        <label className={"fs-7 fw-normal mb-1"}>{x.CustomFieldCaption}</label>

                                                                        <input
                                                                            name={x.DatabaseFieldName}
                                                                            id={x.DatabaseFieldName}
                                                                            value={formik.values[x.DatabaseFieldName] ? formik.values[x.DatabaseFieldName] : ''}
                                                                            //onChange={(e: any) => handleCustomFieldChange(x.DatabaseFieldName, e.target.value)}
                                                                            className={"form-control fs-7 fs-7 fw-normal"}
                                                                            //max={x.MaximumValue !== undefined ? parseFloat(x.MaximumValue) : undefined}
                                                                            //min={x.MinimumValue !== undefined ? parseFloat(x.MinimumValue) : undefined}
                                                                            required={x.IsRequired ? x.IsRequired : ""}
                                                                            type="text"
                                                                            //onBlur={() => handleBlurValidateAll(formik.setFieldTouched, formik.values, formik.validateForm)}
onChange={(e: any) => {
        const inputValue = e.target.value;
        
        // Allow empty value
        if (inputValue === '') {
          handleCustomFieldChange(x.DatabaseFieldName, '');
          return;
        }

        // Validate the input against culture format
        if (validateCultureNumber(inputValue, cultureInfoName.toString(),decimalPlaces)) {
          handleCustomFieldChange(x.DatabaseFieldName, inputValue);
        }
        // If invalid, don't update (keeps previous valid value)
      }}
      onBlur={(e) => {
        // Validate on blur
        const inputValue = e.target.value;
        
        if (inputValue && !validateCultureNumber(inputValue, cultureInfoName.toString(),decimalPlaces)) {
          // Clear invalid value on blur
          handleCustomFieldChange(x.DatabaseFieldName, '');
        }
        
        // Trigger formik validation
        handleBlurValidateAll(formik.setFieldTouched, formik.values, formik.validateForm);
      }}
                                                                            
                                                                        />
                                                                        {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                                            <div style={{ paddingRight: 20 }}>
                                                                                {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                                    <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                                                }
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                )}
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                </div>
                                            }
                                            <div className="d-flex justify-content-end" style={{ padding: '.6rem .6rem' }}>
                                                <button type="button"
                                                    className={`btn btn-primary  btn-bs-btn-font-weight btn-sm p-2 fs-7 ${LockButton ? 'disableClick' : ''}`}
                                                    onClick={
                                                        () => {
                                                            formik.setFieldValue('buttonClicked', 'handleUpdateSheet');
                                                            formik.handleSubmit();
                                                        }
                                                    }
                                                    disabled={AccountEmployeeExpenseSheetId === "" || !formik.isValid || LockButton || (SheetSubmitted && LockSubmittedRecord) || (SheetApproved && LockApprovedRecord)}
                                                >
                                                    {/* {t('Update')} */}
                                                    {getValueFromResource('Update', dispatch, t)}
                                                </button>
                                            </div>
                                        </>
                                    
                                </div>
                            }
                        </div>
                    </>

                </div>
                {isVisible && (
                    <>
                        <div className='bullet bg-secondary h-35px w-1px mx-2'></div>
                        <a id="btnPrintModal"
                            ref={modelRef} type="button"
                            data-bs-toggle={"modal"}
                            data-bs-target="#expenseSheetPrintModal"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t('Print')}
                            {getValueFromResource('Print', dispatch, t)}
                            data-tooltip-place="bottom"
                            onClick={handleOnClickPrintEvent}>
                            <i className="bi bi-printer fs-3 iconColor"></i>
                        </a>
                    </>
                )}

                {/* {isVisible && IsSheetSubmitted && ( */}
                {isVisible && approvalStatus && (
                    <>
                        <div className='bullet bg-secondary h-35px w-1px mx-2'></div>
                        <a id="btnApprovalDetails"
                            ref={modelRefApproval}
                            data-bs-toggle="modal"
                            data-bs-target="#expenseSheetApprovalDetails"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t('Approval Details')}
                            {getValueFromResource('Approval Details', dispatch, t)}
                            data-tooltip-place="bottom"
                            onClick={handleOnClickApprovalEvent}>
                            <i className="bi bi-receipt fs-3 iconColor"></i>
                        </a>
                    </>
                )}

            </div>

            <div className='d-flex align-items-center' style={{ marginTop: 5 }}>
                {isVisible && (
                    // <>
                    //     <div className="position-relative">
                    //         <input
                    //             type="text"
                    //             value={searchTerm}
                    //             onChange={handleSearch}
                    //             placeholder={t('Search')}
                    //             className="form-control h-35px w-150px fs-7 fw-normal pr-4"
                    //             data-kt-user-table-filter="search"
                    //             data-tooltip-id="tooltip-Description"
                    //             data-tooltip-content={t('Search')}
                    //             data-tooltip-place="bottom"
                    //         />
                    //         <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                    //             <span className="path1"></span>
                    //             <span className="path2"></span>
                    //         </i>
                    //     </div>
                    //     <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                    //     <div className="d-flex align-items-center">
                    //         {/* <Select
                    //             styles={colourStylesPage}
                    //             options={options}
                    //             value={options.find(option => parseInt(option.value) == pageSize)}
                    //             onChange={handlePageSizeChange}
                    //             className='fs-7 fw-normal'
                    //         /> */}
                    //    <PageSizeSelect onChange={handlePageSizeChange} />

                    //     </div>  
                    //     <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                    //     <div>
                    //     {(currentItems.length > 0) ? (
                    //             <CustomPagination
                    //                 currentPage={currentPage}
                    //                 onPageChange={handlePageChange}
                    //                 pageSize={pageSize}
                    //                 totalItems={totalItems}
                    //                 start={(currentPage - 1) * pageSize}
                    //             >
                    //             </CustomPagination>
                    //         ) : null}
                    //     </div>
                    //     <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                    // </>
                    <>
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-150px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                data-tooltip-place="bottom"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className="bullet bg-secondary h-35px w-1px mx-3"></div>

                        <div className="d-flex align-items-center">
                            <PageSizeSelect onChange={handlePageSizeChange} />
                        </div>

                        <div className="bullet bg-secondary h-35px w-1px mx-3"></div>

                        {currentItems.length > 0 ? (
                            <>
                                <div>
                                    <CustomPagination
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(currentPage - 1) * pageSize}
                                    />
                                </div>
                                <div className="bullet bg-secondary h-35px w-1px mx-3"></div>
                            </>
                        ) : null}
                    </>
                )}


                {IsAdd && !(LockButton || (SheetSubmitted && LockSubmittedRecord) || (SheetApproved && LockApprovedRecord)) && (
                    <>

                        {isPerDiemVisible === false && (
                            <>
                                {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div> */}
                                <div className='d-flex align-items-center gap-2 gap-lg-3'>
                                    <button
                                        id={(clientArray.length) > 0 ? "kt_OffCanvas" : ""}
                                        type="button"
                                        className={`btn btn-primary btn-bs-btn-font-weight btn-sm ${LockButton ? 'disableClick' : ''}`}
                                        onClick={() => { handleExpenseEntry() }}
                                        disabled={LockButton || isDisable}
                                    >
                                        <KTIcon iconName='plus' className='fs-3' />
                                        {/* {t(`Add Expense Entry`)} */}
                                        {getValueFromResource('Add Expense Entry', dispatch, t)}
                                    </button>
                                </div>
                            </>
                        )}


                        {isPerDiemVisible && (
                            <>
                                <div className="btn-group">
                                    <button
                                        id={(clientArray.length) > 0 ? "kt_OffCanvas" : ""}
                                        type="button"
                                        className={`btn btn-primary btn-bs-btn-font-weight btn-sm ${LockButton ? 'disableClick' : ''}`}
                                        onClick={() => { handleExpenseEntryGroupClick() }}
                                        disabled={LockButton || isDisable}
                                    >
                                        <KTIcon iconName='plus' className='fs-3' />
                                        {/* {t(`Add Expense Entry`)} */}
                                        {getValueFromResource('Add Expense Entry', dispatch, t)}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                        aria-expanded={showDropdown}
                                        id="btnExpenseAndPerdiemIcon"
                                        onClick={handleToggleDropdown}
                                    >
                                        <i className="fa fa-angle-down"></i>
                                    </button>

                                    {/* <ul className={`dropdown-menu${showDropdown ? ' show' : ''} dropdown-menu-right`} role="menu" style={{ position: 'absolute', top: '100%', left: 0 }}> */}
                                    <ul className={`dropdown-menu${showDropdown ? ' show' : ''} dropdown-menu-right px-1 py-1 fs-2`} role="menu" style={{ position: 'absolute', top: '100%', left: 0 }}>
                                        {/* <li>
                                            <a id="btnAddPerDiem"
                                                ref={modelRefPerDiem} type="button"
                                                data-bs-toggle={"modal"}
                                                data-bs-target="#perDiemModal"
                                                className={`btn btn-light-primary btn-sm btnAddPerDiem ${LockButton ? 'disableClick' : ''}`}
                                                data-populate="AddPerDiem"
                                                onClick={LockButton ? () => { } : handleOnClickEvent}>
                                                <KTIcon iconName='plus' className='fs-3' />{t(`Add Per Diem`)}
                                            </a>
                                        </li> */}
                                        <div className='menu-hover-bg-sec'>
                                            <Dropdown.Item
                                                id="btnAddPerDiem"
                                                ref={modelRefPerDiem}
                                                data-bs-toggle={"modal"}
                                                data-bs-target="#perDiemModal"
                                                className="menu-item me-lg-0"
                                                data-populate="AddPerDiem"
                                                onClick={LockButton ? () => { } : handleOnClickEvent}
                                                disabled={LockButton}
                                            >
                                                <span className="menu-icon custom-menu mb-2">
                                                    <i className="bi bi-file-earmark-text fs-6 iconColor">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                <span className="menu-title custom-menu-fontsize" style={{ paddingRight: 6 }}>
                                                    {/* {t(`Add Per Diem`)} */}
                                                    {getValueFromResource('Add Per Diem', dispatch, t)}
                                                </span>
                                            </Dropdown.Item>
                                        </div>
                                    </ul>
                                </div>
                            </>
                        )}
                    </>
                )}

                {isVisible && !(LockButton || (SheetSubmitted && LockSubmittedRecord) || (SheetApproved && LockApprovedRecord)) && (
                    <>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div className='d-flex align-items-center gap-2 gap-lg-3'>
                            <button className={`btn btn-primary btn-sm ${LockButton ? 'disableClick' : ''}`}
                                style={{ marginRight: '2px' }}
                                //onClick={LockButton ? () => { } : handlSubmitSheet}
                                type='button'
                                onClick={
                                    LockButton
                                        ? () => { }
                                        : () => {
                                            formik.setFieldValue('buttonClicked', 'handlSubmitSheet');
                                            formik.handleSubmit(); // Handle form submission with Formik
                                        }
                                }
                                disabled={!formik.isValid}
                            >
                                <i className="bi bi-pencil-square fs-5 me-1"></i>
                                {/* {t('Submit')} */}
                                {getValueFromResource('Submit', dispatch, t)}
                            </button>
                        </div>
                    </>)}

            </div>
            {/* <Tooltip id="tooltip-Description" style={{ fontSize: 12, fontWeight: 600 }} /> */}
            <Tooltip id="tooltip-Description"
                style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}
            />
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 200, minHeight: '35px', height: '35px', padding: '-1px', borderColor: '#EBECF0' })
}

const colourStylesPage: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 80, minHeight: '35px', height: '35px', padding: '-1px', borderColor: '#EBECF0' })
}

export { ToolbarExpense }
